import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'
import { getHeaders } from '../axios/axios-helpers'
import HttpClient from '../axios/http-client'

/* This function calls User Service to request password reset */
export async function resetPasswordRequest(request) {
  const accessToken = sessionStorage.getItem(sessionStorageKeyConstants.ACCESS_TOKEN)
  const headers = getHeaders(accessToken)
  const httpClient = new HttpClient(headers)
  const userInstance = httpClient.userInstance()
  return userInstance.put(`/forgotPassword?email=${request.email}`)
}

/* This function calls User Service to set user's new password */
export async function confirmForgotPassword(request) {
  const accessToken = sessionStorage.getItem(sessionStorageKeyConstants.ACCESS_TOKEN)
  const headers = getHeaders(accessToken)
  const url = '/confirmForgotPassword'
  const httpClient = new HttpClient(headers)
  const userInstance = httpClient.userInstance()
  return userInstance.put(url, request)
}
